import accounts from "./accounts";
import lang from "../../lib/appfuse-react/core/lang";

const accountService = [{
    matcher: 'accounts',
    reply: (config) => {
        if(config.method==='post') {
            return [200, accounts[0]];
        } else {
            const {predicate} = config.params;
            let data;
            const selector = predicate?.node()?.selector?.();
            const children = predicate?.node()?.children?.();
            if (lang.isNotEmpty(selector)) {
                const value = predicate.node().expectation();
                if(lang.isEmpty(value)) {
                    return [200, accounts];
                }
                if(selector === 'name') {
                    const regexp = new RegExp(value.replaceAll('*', '.*'));
                    data = accounts.filter(account => regexp.test(account[selector]));
                } else if(selector === 'username' || selector === 'category') {
                    data = accounts.filter(account => account[selector]===value)
                }
            } else if(lang.isNotEmpty(children)) {
                let tmp = accounts;
                for(let child of children) {
                    const value = child.expectation();
                    if(lang.isEmpty(value)) {
                        continue;
                    }
                    const operator = child.operator();
                    const selector = child.selector();
                    if(selector === 'name') {
                        const regexp = new RegExp(value.replaceAll('*', '.*'));
                        tmp = tmp.filter(account => regexp.test(account[selector]));
                    } else if(selector === 'username' || selector === 'category') {
                        tmp = tmp.filter(account => account[selector]===value);
                    }
                }
                data = tmp;
            } else {
                data = accounts;
            }
            return [200, data];
        }
    }
}, {
    matcher: /accounts\/(.*)/,
    reply: config => {
        const id = /accounts\/(.*)/.exec(config.url)[1];
        const account = accounts.find(account => account.uuid === id);
        return [200, account];
    }
}];

export default accountService;